export default "__VITE_ASSET__ClYDnBoC__"